export default {
  ABSENCE: `Absence`,
  EARLY_OUT: `Départ hâtif`,
  LATE_ARRIVAL: `Retard`,
  ARRIVING: `Arrivée`,
  ARRIVING_AT: `Arrivée à {{ arrivalTime }}`,
  LEAVING: `Départ`,
  LEAVING_AT: `Départ à {{ departureTime }}`,
  AT: 'à'
}
